module.exports = __webpack_public_path__ + "pc-top-assets/img/twitter-black.c1856b95.png";